import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './home';
import Login from './login';
import Logout from './logout';
import Users from './users/users';
import EditUser from './users/user';
import CreateUser from './users/create_user';
import Tokens from './tokens/tokens';
import EditToken from './tokens/token';
import CreateToken from './tokens/create_token';
import CreateGuestToken from './tokens/create_guest_token';
import Balances from './balances/balances';
import EditBalance from './balances/balance';
import Plans from './plans/plans';
import EditPlan from './plans/EditPlan';
import CreatePlan from './plans/CreatePlan';
import Endpoints from './endpoints/endpoints';
import EditEndpoint from './endpoints/EditEndpoint';
import CreateEndpoint from './endpoints/CreateEndpoint';
import EndpointRestrictions from './endpoint_restrictions/endpoint_restrictions';
import EditRestriction from './endpoint_restrictions/EditRestriction';
import CreateRestriction from './endpoint_restrictions/CreateRestriction';
import EndpointUserRestrictions from './endpoint_user_restrictions/endpoint_user_restrictions';
import EditUserRestriction from './endpoint_user_restrictions/EditUserRestriction';
import CreateUserRestriction from './endpoint_user_restrictions/CreateUserRestriction';
import SubscriptionPlans from './subscription_plans/subscription_plans';
import EditSubscriptionPlan from './subscription_plans/EditSubscriptionPlan';
import CreateSubscriptionPlan from './subscription_plans/CreateSubscriptionPlan';
import PointTransactions from './point_transactions/point_transactions';
import SupportTickets from './support_tickets/tickets';
import SupportTicket from './support_tickets/ticket';
import * as Sentry from "@sentry/react";
import config from "./config";
import './App.css';

function App() {

    if (config.sentryDSN) {
        Sentry.init({
            dsn: config.sentryDSN,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Session Replay
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1.0,
        });
    }

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/logout" element={<Logout/>}/>
                    <Route path="/users" element={<Users/>}/>
                    <Route path="/users/:user_id/edit" element={<EditUser/>}/>
                    <Route path="/users/new" element={<CreateUser/>}/>
                    <Route path="/tokens" element={<Tokens/>}/>
                    <Route path="/tokens/:token_id/edit" element={<EditToken/>}/>
                    <Route path="/tokens/new" element={<CreateToken/>}/>
                    <Route path="/tokens/guest/new" element={<CreateGuestToken/>}/>
                    <Route path="/tokens/demo/new" element={<CreateGuestToken forUser/>}/>
                    <Route path="/balances" element={<Balances/>}/>
                    <Route path="/balances/:balance_id/edit" element={<EditBalance/>}/>
                    <Route path="/plans/" element={<Plans/>}/>
                    <Route path="/plans/new" element={<CreatePlan/>}/>
                    <Route path="/plans/:plan_id/edit" element={<EditPlan/>}/>
                    <Route path="/endpoints" element={<Endpoints/>}/>
                    <Route path="/endpoints/new" element={<CreateEndpoint/>}/>
                    <Route path="/endpoints/:endpoint_id/edit" element={<EditEndpoint/>}/>
                    <Route path="/endpoint-restrictions" element={<EndpointRestrictions/>}/>
                    <Route path="/endpoint-restrictions/new" element={<CreateRestriction/>}/>
                    <Route path="/endpoint-restrictions/:restriction_id/edit" element={<EditRestriction/>}/>
                    <Route path="/endpoint-user-restrictions" element={<EndpointUserRestrictions/>}/>
                    <Route path="/endpoint-user-restrictions/new" element={<CreateUserRestriction/>}/>
                    <Route path="/endpoint-user-restrictions/:restriction_id/edit" element={<EditUserRestriction/>}/>
                    <Route path="/subscription-plans" element={<SubscriptionPlans/>}/>
                    <Route path="/subscription-plans/new" element={<CreateSubscriptionPlan/>}/>
                    <Route path="/subscription-plans/:plan_id/edit" element={<EditSubscriptionPlan/>}/>
                    <Route path="/point-transactions" element={<PointTransactions/>}/>
                    <Route path="/support-tickets" element={<SupportTickets/>}/>
                    <Route path="/support-tickets/:ticket_id" element={<SupportTicket/>}/>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
